import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var volumePromotionLevelSchema = {
    from_quantity: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
            step: "1",
            min: "0"
        }),
        elementType: 'input',
        label: 'От количество',
        value: 0,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна стойност',
    }),
    to_quantity: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
            step: "1",
            min: "0"
        }),
        elementType: 'input',
        label: 'До количество',
        value: 0,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна стойност',
    }),
    percent_adjustment: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
            max: '100',
            min: "0"
        }),
        elementType: 'input',
        label: 'Процентна отстъпка',
        value: 0,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна стойност',
    }),
};
export default volumePromotionLevelSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/volumePromotionLevelSchema.ts
// module id = 515
// module chunks = 0